export enum TaskType {
  Website = "Website",
  TelegramBot = "TelegramBot",
  ProductSupport = "Product Support",
  MobileApp = "MobileApp",
  CRMSystem = "CRMSystem",
  Security = "Security",
  APIIntegration = "APIIntegration",
  Another = "Another",
}
